import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // <-- import your main App component
import { createAppKit } from "@reown/appkit/react";
import { WagmiProvider } from "wagmi";

// Import supported networks
import {
  bsc,bscTestnet
} from "@reown/appkit/networks";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

// Setup queryClient for react-query
const queryClient = new QueryClient();

// Fetch the project ID from environment variables
const projectId = process.env.REACT_APP_PROJECT_ID;
if (!projectId) {
  throw new Error("REACT_APP_PROJECT_ID is not set");
}

// Define supported networks
const networks = [bsc,bscTestnet];

// General configuration object
const generalConfig = {
  projectId,
  networks,
};

// Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter(generalConfig);

// Create AppKit modal
createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks,
  features: {
    email: false,
    socials: false,
    emailShowWallets: true,
    onramp: false,
    swaps: false,
    analytics: false,
  },
});


document.documentElement.style.setProperty('--apkt-tokens-theme-text', '#1d1919ff');
document.documentElement.style.setProperty('--apkt-tokens-theme-textInvert', '#131212ff');
document.documentElement.style.setProperty('--apkt-tokens-core-backgroundAccentPrimary-base', 'linear-gradient(100deg, #c49732 0%, #fef979 55%, #e59722 100%)');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
